import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Football américain",
    Baseball: "Baseball",
    Basketball: "Basketball",
    Boxing: "Boxe",
    Chess: "Echecs",
    Cricket: "Cricket",
    Darts: "Fléchettes",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Football",
    "Formula 1": "Formule 1",
    "Gaelic Football": "Football gaélique",
    "Generic Sport": "Generic Sport",
    Golf: "Golf",
    "Greyhound Racing": "Lévriers",
    Handball: "Handball",
    "Ice Hockey": "Hockey sur glace",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Rugby à 13",
    "Rugby Union": "Rugby Union",
    Snooker: "Snooker",
    "Table Tennis": "Tennis de table",
    Tennis: "Tennis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "Victoire de {name}",
    WinFirstRound: "{name} pour remporter le premier tour",
    FirstTouchdown: "{name} pour marquer un touché en premier",
    FirstTry: "{name} pour marquer un essai d'abord",
    TotalGoals: "{name} Total de buts",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total Points",
    TopBatsman: "{name} pour être Top Batteur",
    TopBowler: "{name} pour être Top Lanceur",
    FirstScore: "{name} à marquer en premier"
  },
  PromoTexts: {
    Pick: "Faites vos choix",
    Bet: "Pari",
    Pays: "Gain"
  },
  DateTimeTexts: {
    Today: "Aujourd'hui",
    Tomorrow: "Demain",
    Live: "Réel"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Faites vos choix",
    Return: "Gain",
    Stake: "Pari",
    Draw: "X"
  },
  H2HTexts: {
    goals_scored: "Buts marqués",
    shots: "Tirs",
    shots_on_target: "Tirs cadrés",
    ball_possession: "Possession de balle",
    goals_conceded: "Buts encaissés",
    "Per match": "Par match",
    H2H: "Face à Face",
    W: "V",
    D: "N",
    L: "D",
    T: "N",
    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
